import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { memo, useMemo } from 'react';
import strings from '../../Globalization';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import { useUniqueEffect } from '../../hooks';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';

export const getTranslation = (key) => {
	const cleanKey = key.replace(/[\s\W_]+/g, "");
	const pascalKey = key
    .toLowerCase()
    .replace(/(?:^|\s|[_\W])(\w)/g, (_, c) => c.toUpperCase());
	return strings[key] || 
		   strings[cleanKey] || 
		   strings[cleanKey.toLowerCase()] ||
		   strings[cleanKey.toUpperCase()] ||
		   strings[pascalKey] || key
  };
  

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));
const CriticalParametersTable = () => {
	const { data, setProcessMonitoringValue } = useCycleInfo()

	const criticalParameters = data.CriticalParameters; 
	const [columns, rows] = useMemo(() => {
		const columns = [
			{ name: 'HeaderLabel', label: strings.Parameter },
			{ name: 'MetricDataProperty', label: strings.Metric },
			{ name: 'ActualDataProperty', label: strings.Actual },
			{ name: 'CriticalParameterIcon', label: strings.CriticalParamenterTitle, align: 'center' }
		];
		const rows = criticalParameters.reduce((acc, curr, i) => {
			const row = [];
			if (curr.HeaderLabel) {
				row.push(
					<TableCell
						variant={curr.isTitle ? 'head' : 'body'}
						key={`row${i}-HeaderLabel`}
						align={curr?.align}
						sx={{
							paddingLeft: (theme) => curr.isTitle ? theme.spacing(1) : theme.spacing(2),
						}}
					>
						{`${getTranslation(curr.HeaderLabel)} ${curr.UnitHeader ? `(${curr.UnitHeader})` : ''} ${curr.Index || ''}`}
					</TableCell>
				);
			}
			if (curr.SubHeaderLabel) {
				row.push(
					<TableCell key={`row${i}-SubHeaderLabel`}>
						{
						`${getTranslation(curr.SubHeaderLabel)} ${curr.UnitSubHeader ? ` (${curr.UnitSubHeader})` : ''}`
						}
					</TableCell>
				);
			}
			row.push(<TableCell key={`row${i}-Metric`}>{curr.Metric}</TableCell>);
			row.push(<TableCell key={`row${i}-Actual`}>{curr.Actual}</TableCell>);
			row.push(
				<TableCell align="center" key={`row${i}-CriticalParameterIcon`}>
				<ProcessMonitoringStatus CriticalParameterIcon={curr.CriticalParameterIcon} align={'center'} />
				</TableCell>
			);
			acc.push(row);
			return acc;
		}, []);
		return [columns, rows];
	}, [criticalParameters]);

	const validateProcessMonitoringValue = criticalParameters.filter((ele) => {
		return ele.CriticalParameterIcon === 'fa fa-check icon-check';
	});

	useUniqueEffect(() => {
		if (typeof setProcessMonitoringValue === 'function') {
			if (validateProcessMonitoringValue.length === rows.length) {
				setProcessMonitoringValue(true);
			} else {
				setProcessMonitoringValue(false);
			}
		}
	}, [rows.length]);
	return (
		<Grid container>
			{rows?.length > 0 ? (
				<TableContainer component={Grid} item={12}>
					<Table size="small" aria-label="Critical parameters table">
						<TableHead>
							<TableRow>
								{columns.map((column, index) => (
									<TableCell align={column?.align} key={`column-${index}`}>
										{column.label}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{rows.map((row, index) => (
								<StyledTableRow key={`row-${index}`}>{row}</StyledTableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<Grid size={12}>
					<Box display={'flex'} justifyContent={'center'} textAlign={'center'}>
						<Typography variant="body2" className="text-center">
							No Parameter Data Available for Cycle
						</Typography>
					</Box>
				</Grid>
			)}
		</Grid>
	);
};

export default memo(CriticalParametersTable);
